import 'regenerator-runtime/runtime'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import './index.css'

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || '419994224405-qauhpt9tn9m9d26akpjiapngi70dnhcg.apps.googleusercontent.com'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </GoogleOAuthProvider>
  </React.StrictMode>,
)